import { Component, ElementRef, OnInit } from '@angular/core';
import { NgZone, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { PhotoViewer } from '@awesome-cordova-plugins/photo-viewer/ngx';
import {
  NavController,
  LoadingController,
  NavParams,
  AlertController,
  Platform,
  IonSearchbar,
} from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';
declare var google;
@Component({
  selector: 'app-search-business',
  templateUrl: './search-business.page.html',
  styleUrls: ['./search-business.page.scss'],
})
export class SearchBusinessPage implements OnInit {
  // @ViewChild('mainSearchbar') searchBar:ElementRef;
  @ViewChild(IonSearchbar, { static: false }) searchBar: IonSearchbar;
  resList = [];
  places: any;
  searchRest: any;
  searchCusine = '';
  search: boolean = false;
  searchItems: any;
  status: boolean = true;
  toggle = '00';
  new: any;
  addressSearch: boolean = false;
  geo: any;
  temp: boolean = true;
  autocompleteItems: any;
  autocomplete: any;
  myFavorites = [];
  service = new google.maps.places.AutocompleteService();
  cuisinesList = [];
  filteredList = [];
  activeCuisineName = '';
  newCuisineList = [];
  searchedresults = [];
  noResultsFound = false;
  loading: any;
  showLoading: boolean = false;
  dataNotLoaded: boolean = true;
  // slidesImages = [
  //   {
  //     slideImage: "../../assets/imgs/back1.jpg", text: ""
  //   },
  //   {
  //     slideImage: "../../assets/imgs/slide1.jpg", text: ""
  //   },
  //   {
  //     slideImage: "../../assets/imgs/slide2.jpg", text: ""
  //   },
  //   {
  //     slideImage: "../../assets/imgs/slide3.jpg", text: ""
  //   }
  // ]
  // activeCuicineList='all';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public globals: GlobalVariable,
    public server: ServerService,
    public loadingCtrl: LoadingController,
    private photoViewer: PhotoViewer,
    private geolocation: Geolocation,
    public alertCtrl: AlertController,
    public zone: NgZone,
    public platform: Platform,
    public router: Router
  ) {
    this.autocompleteItems = [];
    this.autocomplete = {
      query: '',
    };
    // this.allaRestaurantsList();
    this.globals.checkGPSPermission();
  }
  ionViewWillEnter() {
    this.getFavorites();
    // this.getLocation();
    // this.list();
    this.getCuisinesList();
    this.getCuisineListFiltered();
  }
  ngOnInit(): void {}
  ionViewDidEnter() {
    this.resList = [];
    // document.getElementById(this.globals.cuisineID).scrollIntoView();
    setTimeout(() => {
      this.resList = [];
      this.searchBar.setFocus();
    }, 150);
  }
  getFavorites() {
    let res = JSON.parse(localStorage.getItem('myFavorites'));
    console.log(res);
    if (res != null) {
      this.myFavorites = res;
      console.log('My fav', this.myFavorites);
    }
  }
  segmentChange(e) {
    this.globals.activeCuisineList = e.detail.value;
    // this.globals.activeCuisineList
    console.log(e, this.globals.activeCuisineList);
  }
  selectedFriends() {
    this.list();
  }
  getCuisinesList() {
    let response = this.server.getCuisines();
    response.subscribe((data) => {
      this.dataNotLoaded = false;
      console.log('cuisines data', data);
      // if(data.reponse==true){
      this.cuisinesList = data.data;
      this.newCuisineList = this.cuisinesList;
      console.log('cuisines data', this.cuisinesList);

      // console.log('active cuisine id ',this.globals.cuisineID)

      // }
    });
  }
  setActiveCuisine(data, id, index) {
    this.globals.activeCuisine = data;
    this.globals.cuisineID = id;
    this.activeCuisineName = data.title;
    this.globals.activeCuisineName = data.title;
    console.log('name', this.activeCuisineName);
    console.log('cuisineID updated', this.globals.cuisineID);

    if (id != undefined && id != null) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    }
    // document.getElementById(id).scrollIntoView();
    // let idscr=document.querySelector('active_text')
    // idscr.scrollIntoView();
    this.getCuisineListFiltered();
  }
  removeFavorite(favItem, index) {
    if (index > -1) {
      this.myFavorites.splice(index, 1);
      console.log(this.myFavorites.length);
      localStorage.setItem('myFavorites', JSON.stringify(this.myFavorites));
      this.globals.presentToast(favItem.name + ' Removed from favorites');
    }
  }
  saveAddress() {
    this.globals.address = this.autocomplete.query;
    this.addressSearch = false;
  }
  editAddress() {
    this.addressSearch = true;
  }
  dismiss() {
    this.temp = false;
    this.autocompleteItems = [];
  }
  chooseItem(item: any) {
    this.autocomplete.query = item;
    this.geo = item;
    this.dismiss();
    this.geoCode(this.geo);
    console.log('item', item);
    console.log('geo', this.geo);
  }
  geoCode(address: any) {
    // let that = this;
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, (results, status) => {
      this.globals.mycoordinates =
        results[0].geometry.location.lat() +
        ',' +
        results[0].geometry.location.lng();
      this.list();
    });
  }
  updateSearch() {
    console.log('search is on');
    console.log(this.autocompleteItems);
    console.log('length', this.autocomplete.query.length);

    if (this.autocomplete.query == '') {
      console.log('if run');
      this.autocompleteItems = [];
      this.temp = false;
      return;
    } else if (this.autocomplete.query.length >= 3) {
      console.log('else if run');
      this.temp = true;
      let me = this;
      this.service.getPlacePredictions(
        {
          input: this.autocomplete.query,
          componentRestrictions: {
            country: 'us',
          },
        },
        (predictions, status) => {
          me.autocompleteItems = [];

          me.zone.run(() => {
            if (predictions != null) {
              predictions.forEach((prediction) => {
                me.autocompleteItems.push(prediction.description);
                console.log(me.autocompleteItems);
              });
            }
          });
        }
      );
    } else {
      console.log('else run');
    }
  }
  getLocation() {
    this.geolocation.getCurrentPosition().then(
      (position) => {
        this.addressSearch = false;
        this.globals.mycoordinates =
          position.coords.latitude + ',' + position.coords.longitude;
        this.reverseGeoCoding();
        this.list();
      },
      async (err) => {
        let alert = await this.alertCtrl.create({
          header: this.globals.locationAlert_title,
          subHeader: this.globals.locationAlert_text,
          buttons: [
            {
              text: 'Cancel',
              handler: (data) => {
                this.list();
                // console.log('Cancel clicked');
              },
            },
            {
              text: 'OK',
              handler: (data) => {
                this.list();
                // console.log('Ok clicked');
              },
            },
          ],
        });

        alert.present();
        // console.log(err);
      }
    );
  }

  reverseGeoCoding() {
    let response = this.server.getAddress(this.globals.mycoordinates);
    var myadress = '';
    response.subscribe(
      (data) => {
        myadress = data.address;
        this.globals.address = myadress;
      },
      (error) => {
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AllRestaurantListPage');
  }
  ionViewWillLeave() {
    this.globals.dataNotLoaded = true;
    this.dataNotLoaded = true;
    console.log('leaving landing page');
    // this.pageLoading();
    // if(this.showLoading==true){
    //  this.loading.dismiss()
    // }
  }

  //   allaRestaurantsList() {
  //     let loading = this.loadingCtrl.create({
  //       content: "Loading...",
  //   });
  //   loading.present();

  //     let response = this.server.getAllRestaurantslist('100000', 'main', "0,0", '0', 'order');
  //         response.subscribe(data => {
  //           console.log(data)
  //           this.resList = data.results;
  //           loading.dismiss();

  //   }, error => {
  //     loading.dismiss();
  //     this.globals.presentToast("Something went wrong check your internet connection.")
  // });
  //   }
  toggleGallery(list) {
    // console.log(list);
    list.toggle = list.business_id;
  }
  cancelAddressSearch() {
    this.addressSearch = false;
  }
  toggleList(list) {
    list.toggle = undefined;
  }
  showImage(image) {
    this.photoViewer.show(image, '', { share: true });
  }
  openReviews(id, username) {
    this.navCtrl.navigateForward('/reviews', {
      state: { reviewData: id, place: username },
    });
    // this.navCtrl.push("ReviewsPage", { reviewData: id, place: username });
    // }`reviews/${this.globals.activeBusinessData.name}`
  }
  async pageLoading() {
    this.loading = await this.loadingCtrl.create({
      message: '<img src="assets/imgs/preloader.gif" alt="loading...">',
      cssClass: 'custom_loading',

      // showBackdrop: false,
      // spinner: 'hide',
    });
    await this.loading.present();
  }
  orderNow(business) {
    this.showLoading = true;
    // this.pageLoading();
    // console.log(business)
    this.globals.bussinessId = business.business_id;
    this.globals.new_id = business.business_id;
    // this.list();
    // if (this.globals.branch_enabled == 1) {
    //   this.navCtrl.push('ResturantListPage')
    // } else {
    //   this.navCtrl.push('CategoryPage')
    // }
    // this.navCtrl.push("CategoryPage", { businessData: business,uniqueid:business.business_id });
    //categorypage add krna hai
    let name = business.name + '-' + business.address;
    name = name.replace(/[^a-zA-Z ]/g, '');
    name = name.replace(/ /g, '-');
    name = name.replace(/--/g, '-');
    // let length=name.length+1;
    // let arrays =name[length].replace('-','')

    this.router.navigateByUrl('' + name + '/' + business.business_id, {
      state: { businessData: business, uniqueid: business.business_id },
    });
    // this.navCtrl.navigateForward('/business-details/'+business.business_id, { state: {  businessData: business,uniqueid:business.business_id  } })
  }

  setFilteredCuisine() {
    //search................
    this.search = true;
    this.globals.activeCuisineList = 'all';
    console.log('Entered text', this.searchCusine);

    if (this.searchCusine != '') {
      console.log('keyword has data');
      this.cuisineListSearched();
    } else if (this.searchCusine == '') {
      console.log('search cleared...');
      this.noResultsFound = false;
      this.search=false;

      // this.list();
    }
    // else if(this.searchCusine == ""){
    //   this.getCuicineListFiltered();
    // }
  }
  // filterCuisines(searchTerm) {
  //   return this.cuisinesList.filter((item) => {
  //     console.log('data',item)
  //     return item.title.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
  //   });
  // }
  setFilteredRest() {
    this.search = true;

    // let loading = this.loadingCtrl.create({
    //   content: "Please wait...",
    // });
    // loading.present().then(() => {
    // console.log("Search rest", this.searchRest);
    // loading.dismiss();
    if (this.searchRest != '') {
      // loading.dismiss();
      this.searchItems = this.filterItems(this.searchRest);
      //storing list to a new array
      // this.new=this.resList;
      this.resList = this.searchItems;
      // console.log("After Search ", this.searchItems);
    } else if (this.searchRest == '') {
      this.list();
      // loading.dismiss();
      this.searchItems = [];
      this.resList = this.new;
      // console.log(this.resList);
      // this.status = false;
    }
    // });
  }

  filterItems(searchTerm) {
    // this.list();
    return this.resList.filter((item) => {
      // console.log("Item ", item);
      return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
  }

  emptySearch() {
    this.search = false;
    this.status = false;
    this.searchCusine = '';
    this.noResultsFound = false;
    this.searchItems = [];
  }
  cuisineListSearched() {
    let response = this.server.getCuisineSearchedList(
      // this.globals.radius,
      // "main",
      // this.globals.mycoordinates,
      // "0",//offset
      // "order",
      // 100,//limit
      this.searchCusine
    );
    response.subscribe(
      (data) => {
        this.search = false;
        console.log('search results', data);
        if (data.status == 'true' && data.results != null) {
          this.searchedresults = data.results;
          if (this.searchedresults.length == 0) {
            console.log('nothing found');
            this.noResultsFound = true;
          } else {
            this.noResultsFound = false;
            this.resList = this.searchedresults;
          }
        } else if (data.status == 'false') {
          console.log('nothing found');
          this.noResultsFound = true;
          this.searchedresults = [];
        }
      },
      (err) => {
        console.log(err);
        this.search = false;
        this.globals.presentToast('Something went wrong...');
      }
    );
  }
  home() {
    this.navCtrl.navigateRoot('home');
  }
  getCuisineListFiltered() {
    // let loading = this.loadingCtrl.create({
    //   content: "Getting...",
    // });
    // loading.present();
    let response = this.server.getCuisinesList(
      '10000',
      'main',
      this.globals.mycoordinates,
      '0', //offset
      'order',
      100, //limit
      this.globals.cuisineID //cuicine_id
    );

    response.subscribe(
      (data) => {
        this.globals.dataNotLoaded = false;
        this.search = false;

        // loading.dismiss();

        console.log('cuisineList ', data);
        if (data.status == 'true') {
          this.filteredList = data.results;
          console.log(this.globals.cuisineID, ' has data');
          if (
            this.globals.cuisineID != undefined &&
            this.globals.cuisineID != null &&
            this.dataNotLoaded == false
          ) {
            document
              .getElementById(this.globals.cuisineID)
              .scrollIntoView({ behavior: 'smooth' });
          }

          console.log('and data is ', this.filteredList);
        } else {
          console.log(this.globals.cuisineID, ' no data');
          if (
            this.globals.cuisineID != undefined &&
            this.globals.cuisineID != null &&
            this.dataNotLoaded == false
          ) {
            document
              .getElementById(this.globals.cuisineID)
              .scrollIntoView({ behavior: 'smooth' });
          }
          this.filteredList = [];
        }
        // if(data.status='false'){

        // }
      },
      (error) => {
        console.log(error);

        // loading.dismiss();
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
    this.globals.dataNotLoaded = true;
  }
  list() {
    // let loading = this.loadingCtrl.create({
    //   content: "Fetching Data...",
    // });
    // loading.present();
    let response = this.server.getRestaurantslist(
      '10000',
      'main',
      this.globals.mycoordinates,
      0,
      'order',
      100
    );
    response.subscribe(
      (data) => {
        this.search = false;
        this.globals.dataNotLoaded = false;
        // loading.dismiss();
        this.places = data.results;
        this.globals.business_list = data.results;
        this.resList = data.results;
        this.new = data.results;
      },
      (error) => {
        // loading.dismiss();
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }
  lengthGet(x) {
    if (x.length > 0) {
      return true;
    } else {
      return false;
    }
  }
}
